/**
 * Constante con secciones mapeadas y devueltas por backend para validaciones de acceso.
 */
export const MAPPED_ACCESS_ROLE_SECTIONS = {
  CONTACTS: 'CONTACTS',
  PROFILE: 'PROFILE',
  WALLET: 'WALLET',
  MANAGE_TEAM: 'MANAGE_TEAM',
  PENDING_APPROVALS: 'PENDING_APPROVALS',
  TRANSACTIONS: 'TRANSACTIONS',
  COMEX: 'COMEX',
  CARD: 'CARD',
  SHAREHOLDERS: 'SHAREHOLDERS',
  WEBHOOKS: 'WEBHOOKS',
  RFQ: 'RFQ',
  BREB: 'BREB',
  COLLECT: 'COLLECT',
} as const;

/**
 * Constante con secciones no mapeadas por el backend, utilizadas para excluir a usuarios con máximo nivel de restricciones de acceso,
 * sin  contrastar el acceso con el array devuelto por backend.
 */
export const UNMAPPED_ACCESS_ROLE_SECTIONS = {
  SEND: 'SEND',
  HOME: 'HOME',
} as const;

export const ACCESS_ROLE_SECTIONS = {
  ...MAPPED_ACCESS_ROLE_SECTIONS,
  ...UNMAPPED_ACCESS_ROLE_SECTIONS,
} as const;

export const ACCESS_ROLE_ACTIONS = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  DELETE: 'DELETE',
  USER: 'USER',
  COMPANY: 'COMPANY',
  DOCUMENTS: 'DOCUMENTS',
  SECURITY: 'SECURITY',
  ADD_CURRENCY: 'ADD_CURRENCY',
  ADD_FOUNDS: 'ADD_FOUNDS',
  SEND: 'SEND',
  EXCHANGE: 'EXCHANGE',
  DOWNLOAD_DOCUMENTS: 'DOWNLOAD_DOCUMENTS',
  CREATE_RESEND: 'CREATE_RESEND',
  CANCEL: 'CANCEL',
  BLOCK_UNBLOCK: 'BLOCK_UNBLOCK',
  MAKE: 'MAKE',
  INDIVIDUAL_SEND: 'INDIVIDUAL_SEND',
  MULTI_SEND: 'MULTI_SEND',
  P2P_SEND: 'P2P_SEND',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  VIEW_TRANSACTIONS: 'VIEW_TRANSACTIONS',
  VIEW_MULTI_SENDS: 'VIEW_MULTI_SENDS',
  REUSE_MULTI_SEND: 'REUSE_MULTI_SEND',
  RENEW: 'RENEW',
  DOWNLOAD_STATEMENT: 'DOWNLOAD_STATEMENT',
  VIEW_INVITATIONS: 'VIEW_INVITATIONS',
  LEGALIZE: 'LEGALIZE',
  VIEW_USERS: 'VIEW_USERS',
  DECLARE: 'DECLARE',
  CREATE_WEBHOOK: 'CREATE_WEBHOOK',
  CREATE: 'CREATE',
  BLOCK: 'BLOCK',
  UNBLOCK: 'UNBLOCK',
  EXTEND_BLOCK: 'EXTEND_BLOCK',
  PAY: 'PAY',
  CREATE_QR: 'CREATE_QR',
  ACCEPT_TC: 'ACCEPT_TC',
} as const;
